import PropTypes from "prop-types";
import React from "react";
import ReactSequenceViewer from "react-sequence-viewer";
import { Link } from "react-router-dom";
import "./PartPreview.css";

const PartPreview = ({ createdBy, name, sequence, deletePart }) => (
  <div className="partPreview">
    <div className="card">
      <div className="card-header">
        <Link to={`/${createdBy}/${name}`}>{name}</Link>
        {deletePart != null && (
          <span
            className="btn btn-outline-dark btn-sm x-out"
            role="button"
            tabIndex="0"
            onClick={() => deletePart(createdBy, name)}
          >
            &times;
          </span>
        )}
      </div>
      <div className="card-body">
        {(sequence || null) && (
          <ReactSequenceViewer
            className="viewer"
            id={`${createdBy}${name}`}
            badge={false}
            charsPerLine={40}
            search
            sequence={sequence}
            sequenceMaxHeight="160px"
            title=""
          />
        )}
      </div>
    </div>
  </div>
);

PartPreview.propTypes = {
  createdBy: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  sequence: PropTypes.string.isRequired,
  deletePart: PropTypes.func,
};

PartPreview.defaultProps = {
  deletePart: null,
};

export default PartPreview;



// WEBPACK FOOTER //
// ./src/components/PartPreview/PartPreview.js